//React
//Components
import {
  Button,
  FlexBox,
  Image,
  Input,
  Screen,
  TranslatedString,
} from "components";
import React, { useEffect, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import { setGeneralDetails, useGeneralDetails } from "Slices";
//Utils
import { ChangeHistory, getURLParameter } from "utils";
//Styles
import "./styles.scss";
//Libraries
import cx from "classnames";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
//Assets
import Tanmay from "assets/tanmay.svg";
import secureLocalStorage from "react-secure-storage";

const Landing = () => {
  const [hideIntro, setHideIntro] = useState(false);
  const [email, setEmail] = useState("");
  const [orgName, setOrgName] = useState("");
  useEffect(() => {
    const mid = getURLParameter("mid") || secureLocalStorage.getItem("mid");
    const mtId = getURLParameter("mtId") || secureLocalStorage.getItem("mtId");
    if (mid && mtId) {
      getURLParameter("mid") &&
        secureLocalStorage.setItem("mid", getURLParameter("mid"));
      getURLParameter("mtId") &&
        secureLocalStorage.setItem("mtId", getURLParameter("mtId"));
      window.history.pushState(
        {},
        document.title,
        window.location.href.split("?")[0]
      );
      window
        .fetch("https://metaverse.otpless.app/v1/merchant/getMerchantDetails", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({
            mid,
            mtId,
            utm: window.location.href,
            utm_source: getURLParameter("utm_source"),
            utm_medium: getURLParameter("utm_medium"),
            utm_campaign: getURLParameter("utm_campaign"),
          }),
        })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setOrgName(data?.data?.orgDomain);
            setEmail(data?.data?.email);
            console.log({
              email: data?.data?.email,
            });
            window?.ChiliPiper?.submit("otpless", "tech_router", {
              formId: "form_Id",
              domElement: "#chillipiper",
              onSuccess: chilipiperOnSuccess,
            });
          } else {
            secureLocalStorage.removeItem("mid");
            secureLocalStorage.removeItem("mtId");
            ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
          }
        });
    } else {
      ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
    }
  }, []);

  const chilipiperOnSuccess = (data) => {
    setHideIntro(true);
  };

  //Return UI
  return (
    <Screen className="help-new-screen" hasHeader>
      <FlexBox flexColumn className="middle-section">
        <div className={cx(hideIntro && "dsp-n", "w-100 pd-10 tanmay-div")}>
          <FlexBox justifyBetween alignCenter>
            <Image src={Tanmay} className="w-15" />
            <p className="w-85 mr-l-20">
              Hey, I am Tanmay Sagar, one of the co-founders.{" "}
            </p>
          </FlexBox>
          <p className="mr-t-10">
            Please pick a date and time for our meeting to integrate WhatsApp
            Login at <span className="font-heavy">{orgName}</span>
          </p>
        </div>
        <form id="form_Id" className="w-100">
          <Input
            onChange={({ target }) => {}}
            value={"OTPless"}
            placeholder="Enter your first name"
            className="mr-b-20 fs-16"
            others={{
              id: "firstname",
              name: "firstname",
            }}
          />
          <Input
            onChange={({ target }) => {}}
            value={"Merchant"}
            placeholder="Enter your last name"
            className="mr-b-20 fs-16"
            others={{
              id: "lastname",
              name: "lastname",
            }}
          />
          <Input
            type="email"
            onChange={({ target }) => {}}
            value={email}
            placeholder="Enter your email address"
            className="mr-b-20 fs-16 h-0 overflow-hdn o-0 pd-0 mr-0"
            others={{
              id: "email",
              name: "email",
            }}
          />
        </form>
        <div id="chillipiper" className={cx(hideIntro && "full-page")}></div>
      </FlexBox>
    </Screen>
  );
};

export default Landing;
